import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  ICreateDocumentSubmissionInput,
  IDocumentSubmission,
} from 'types/submissions'

export const documentSubmissionApi = createApi({
  reducerPath: 'documentSubmissions',
  baseQuery,
  tagTypes: ['DocumentSubmissions'],
  endpoints: (builder) => ({
    documentSubmissions: builder.query<IDocumentSubmission[], { lotId: string }>({
      query: ({ lotId }) => {
        return {
          url: '/document-submissions',
          method: 'get',
          params: {
            lotId,
          },
        }
      },
      providesTags: ['DocumentSubmissions'],
    }),

    createDocumentSubmission: builder.mutation<void, ICreateDocumentSubmissionInput>(
      {
        query: (body) => ({
          url: `/document-submissions`,
          body,
          method: 'post',
        }),
        invalidatesTags: ['DocumentSubmissions'],
      }
    ),
  }),
})

export const { useDocumentSubmissionsQuery, useCreateDocumentSubmissionMutation } =
  documentSubmissionApi
